/*! LBJ Wishlist v2.4 — bubble fully hidden at 0, no “0” text, instant mobile toggle */
;(() => {
  const KEY = "lbj_wishlist_v1"
  const S = {
    btn: "[data-wishlist-btn]",
    count: "[data-wishlist-count]",
    grid: "#wishlist-grid",
    empty: "#wishlist-empty",
    toast: "#wishlist-toast",
    open: "[data-wishlist-open]",
    close: "[data-wishlist-close]",
    drawer: "#WishlistDrawer",
    dialog: "#WishlistDrawer .cart-drawer__dialog",
  }

  // ---------------- state ----------------
  const state = {
    get() {
      try {
        return JSON.parse(localStorage.getItem(KEY)) || []
      } catch (_) {
        return []
      }
    },
    set(list) {
      localStorage.setItem(KEY, JSON.stringify(Array.from(new Set(list))))
      emit("lbj:wishlist:change")
    },
    has(h) {
      return state.get().includes(h)
    },
    add(h) {
      const l = state.get()
      if (!l.includes(h)) {
        l.push(h)
        state.set(l)
      }
    },
    remove(h) {
      state.set(state.get().filter((x) => x !== h))
    },
    toggle(h) {
      state.has(h) ? state.remove(h) : state.add(h)
    },
  }

  // ------------- price cache -------------
  // Stores display prices keyed by handle so closing-sale discounts are
  // preserved in the drawer even though /products/{handle}.js has no metafields.
  const PRICE_KEY = "lbj_wishlist_prices_v1"
  const priceCache = {
    get() {
      try { return JSON.parse(localStorage.getItem(PRICE_KEY)) || {} } catch (_) { return {} }
    },
    set(handle, data) {
      const cache = this.get()
      cache[handle] = data
      try { localStorage.setItem(PRICE_KEY, JSON.stringify(cache)) } catch (_) {}
    },
    remove(handle) {
      const cache = this.get()
      delete cache[handle]
      try { localStorage.setItem(PRICE_KEY, JSON.stringify(cache)) } catch (_) {}
    },
    lookup(handle) {
      return this.get()[handle] || null
    },
  }

  // --------------- utils -----------------
  function escHtml(s) { const d = document.createElement("div"); d.textContent = s; return d.innerHTML }
  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail }))
  }
  function $$(sel, ctx) {
    return Array.from((ctx || document).querySelectorAll(sel))
  }

  function getHandleFrom(el) {
    if (!el) return null
    let h = el.dataset?.productHandle || el.dataset?.handle
    if (h) return h
    h = el.getAttribute?.("data-product-handle") || el.getAttribute?.("data-handle")
    if (h) return h
    let n = el.parentElement,
      i = 0
    while (n && i++ < 5) {
      h = n.dataset?.productHandle || n.dataset?.handle
      if (h) return h
      h = n.getAttribute?.("data-product-handle") || n.getAttribute?.("data-handle")
      if (h) return h
      n = n.parentElement
    }
    return null
  }

  function hydrateButtons() {
    $$(S.btn).forEach((btn) => {
      const h = getHandleFrom(btn)
      if (!h) return
      const on = state.has(h)
      btn.classList.toggle("is-active", on)
      btn.setAttribute("aria-pressed", String(on))
    })
  }

  // Toggle has-items on header icon based on current wishlist count
  function updateCount() {
    const count = state.get().length
    document.querySelectorAll(".header-actions__wishlist-icon").forEach((btn) => {
      btn.classList.toggle("has-items", count > 0)
      btn.setAttribute("data-wishlist-count", String(count))
    })
  }

  // --------------- data ------------------
  function fetchProduct(handle) {
    return fetch(`/products/${handle}.js`, { credentials: "same-origin" }).then((r) => {
      if (!r.ok) throw new Error("fetch failed")
      return r.json()
    })
  }

  function formatMoney(cents) {
    const n = Number(cents) / 100
    try {
      const ccy = window.Shopify?.currency?.active || "AUD"
      return new Intl.NumberFormat(undefined, { style: "currency", currency: ccy }).format(n)
    } catch (_) {
      return `$${n.toFixed(2)}`
    }
  }

  // -------------- drawer -----------------
  function drawerRoot() {
    return document.querySelector(S.drawer)
  }
  function drawerDialog() {
    return document.querySelector(S.dialog)
  }
  function isOpen() {
    return drawerRoot()?.getAttribute("aria-hidden") === "false"
  }

  let _intentOpen = false

  function syncDrawerHeaderHeight() {
    const headerRow = document.querySelector('.header__row--top')
    let h = 0
    if (headerRow) h = Math.round(headerRow.getBoundingClientRect().top)
    if (h <= 0) {
      const annc = document.querySelector('.lb-announcement-bar') || document.querySelector('.announcement-bar')
      if (annc) h = Math.round(annc.getBoundingClientRect().height)
    }
    if (h <= 0) return
    document.documentElement.style.setProperty('--annc-bar-height', h + 'px')
    const root = drawerRoot()
    if (root) root.querySelectorAll('.lbj-cart-header').forEach(el => { el.style.height = h + 'px' })
  }

  function openWishlist() {
    _intentOpen = true
    const root = drawerRoot()
    if (!root) return
    const dlg = drawerDialog()

    syncDrawerHeaderHeight()

    document.querySelectorAll('.menu-list__link[aria-expanded="true"]').forEach(function (l) {
      l.setAttribute('aria-expanded', 'false')
      l.classList.remove('menu-list__link--active')
    })

    // Suppress smooth-scroll on html before locking — prevents it animating to top when body leaves flow
    document.documentElement.style.scrollBehavior = 'auto'
    const scrollY = window.scrollY
    document.body.dataset.scrollY = scrollY
    document.body.style.width = "100%"
    document.body.style.position = "fixed"
    document.body.style.top = `-${scrollY}px`
    document.body.dataset.drawerOpen = '1'

    root.hidden = false
    root.setAttribute("aria-hidden", "false")
    root.classList.add("is-open")

    if (dlg && !dlg.open) {
      try {
        dlg.show()
      } catch (_) {
        dlg.setAttribute("open", "")
      }
    }

    const grid = root.querySelector(S.grid)
    if (grid) renderGrid(grid)
  }

  function closeWishlist() {
    _intentOpen = false
    const root = drawerRoot()
    if (!root) return
    const dlg = drawerDialog()

    root.classList.remove("is-open")
    root.setAttribute("aria-hidden", "true")

    // Restore scroll position after releasing the body lock
    const scrollY = parseInt(document.body.dataset.scrollY || "0", 10)
    document.body.style.position = ""
    document.body.style.top = ""
    document.body.style.width = ""
    delete document.body.dataset.scrollY
    window.scrollTo(0, scrollY)
    document.documentElement.style.scrollBehavior = ''
    delete document.body.dataset.drawerOpen

    if (dlg && dlg.open && typeof dlg.close === "function") {
      try {
        dlg.close()
      } catch (_) {
        dlg.removeAttribute("open")
      }
    }

    setTimeout(() => {
      root.hidden = true
    }, 250)
  }

  // -------------- render -----------------
  async function renderGrid(grid) {
    const handles = state.get()
    const empty = document.querySelector(S.empty)
    const itemsWrap = grid.closest(".cart-drawer__items")
    const signinWrap = grid.closest(".cart-drawer__content")?.querySelector(".cart-drawer__signin")

    const emailCapture = document.getElementById("wl-email-capture")

    if (handles.length === 0) {
      grid.innerHTML = ""
      if (itemsWrap) itemsWrap.classList.add("is-empty")
      if (empty) empty.hidden = false
      if (signinWrap) signinWrap.hidden = true
      if (emailCapture) emailCapture.hidden = true
      return
    }

    if (itemsWrap) itemsWrap.classList.remove("is-empty")
    if (empty) empty.hidden = true
    if (signinWrap) signinWrap.hidden = false
    if (emailCapture) emailCapture.hidden = false

    grid.innerHTML = `<div class="lbj-wl-loading">Loading…</div>`
    try {
      const results = await Promise.allSettled(handles.map(fetchProduct))

      const ok = results
        .filter(r => r.status === "fulfilled")
        .map(r => r.value)

      const badHandles = results
        .map((r, i) => (r.status === "rejected" ? handles[i] : null))
        .filter(Boolean)

      // Auto-remove broken items so it won’t keep failing forever
      if (badHandles.length) {
        const cleaned = handles.filter(h => !badHandles.includes(h))
        state.set(cleaned)
      } 

      if (!ok.length) {
        grid.innerHTML = ""
        if (itemsWrap) itemsWrap.classList.add("is-empty")
        if (empty) empty.hidden = false
        if (signinWrap) signinWrap.hidden = true
        return
      }

      if (itemsWrap) itemsWrap.classList.remove("is-empty")
      if (empty) empty.hidden = true






      grid.innerHTML = `
        <div class="wishlist-cartlike-list cart-items__wrapper">
          <div class="cart-items cart-items--dividers">
            <div class="cart-items__table" role="table">
              ${ok
                .map((p) => {
                  const v = p.variants.find((variant) => variant.available) || p.variants[0]
                  const cached = priceCache.lookup(p.handle)
                  let price, compareAt
                  if (cached && cached.price) {
                    price = formatMoney(Number(cached.price))
                    compareAt = cached.compare && Number(cached.compare) > Number(cached.price)
                      ? formatMoney(Number(cached.compare))
                      : ""
                  } else {
                    price = v ? formatMoney(v.price) : ""
                    compareAt = v && Number(v.compare_at_price) > Number(v.price) ? formatMoney(v.compare_at_price) : ""
                  }
                  const img = p.images && p.images[0] ? p.images[0] : p.featured_image || ""
                  const variantText =
                    v &&
                    Array.isArray(v.options) &&
                    !(v.options.length === 1 && String(v.options[0]).trim().toLowerCase() === "default title")
                      ? v.options.filter(Boolean).join(", ")
                      : ""

                  return `
                    <article class="cart-items__table-row cart-items__table-row--wishlist" data-handle="${p.handle}">
                      <div class="cart-items__media">
                        ${
                          img
                            ? `
                              <a href="/products/${p.handle}" class="cart-items__media-container" style="--ratio:1;">
                                <img
                                  loading="lazy"
                                  src="${img}"
                                  alt="${escHtml(p.title)}"
                                  class="cart-items__media-image border-style"
                                >
                              </a>
                            `
                            : ``
                        }
                      </div>

                      <div class="cart-items__details cart-primary-typography">
                        <p>
                          <a href="/products/${p.handle}" class="cart-items__title">${escHtml(p.title)}</a>
                        </p>

                        ${
                          variantText
                            ? `
                              <dl class="cart-items__variants">
                                <div class="cart-items__variant">
                                  <dd>${variantText}</dd>
                                </div>
                              </dl>
                            `
                            : ``
                        }

                        <div class="wishlist-item-price">
                          <span>${price}</span>
                          ${compareAt ? `<s class="compare-at-price">${compareAt}</s>` : ``}
                        </div>
                      </div>

                      <div class="cart-items__quantity cart-items__quantity--wishlist">
                        ${
                          v && v.available && !(p.tags && (p.tags.includes("loose-pink-diamond") || p.tags.includes("loose-blue-diamond")))
                              ? `
                                <button
                                  class="lbj-viewbag-button--mini wishlist-add-to-bag lbj-wl-add"
                                  type="button"
                                  data-variant-id="${v.id}"
                                >
                                  <span class="lbj-viewbag-text">Add to Bag</span>
                                  <span class="chevron">›</span>
                                </button>
                              `
                              : ``
                        }

                        <button
                          class="button button--tertiary cart-items__remove lbj-wl-remove"
                          type="button"
                          aria-label="Remove ${escHtml(p.title)} from wishlist"
                          data-remove="${p.handle}"
                        >
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                            <path d="M11.5 9v4.25M8.5 9v4.25M5.75 12.2V6h8.5c0 2.421 0 3.779 0 6.2 0 .853 0 1.447-.038 1.91-.037.453-.106.714-.207.911a2.498 2.498 0 0 1-.983 1.017c-.197.1-.458.17-.911.207-.463.037-1.057.038-1.91.038h-.4c-.853 0-1.447 0-1.91-.038-.453-.037-.714-.106-.911-.207a2.498 2.498 0 0 1-.984-1.017c-.1-.197-.17-.458-.207-.911C5.75 13.647 5.75 13.053 5.75 12.2z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                            <path d="M4.25 6h11.5M8 5.25a2 2 0 1 1 4 0" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <span class="visually-hidden">Remove</span>
                        </button>
                      </div>
                    </article>
                  `
                })
                .join("")}
            </div>
          </div>

        </div>
      `












      if (!grid._delegated) {
        grid.addEventListener("click", async (e) => {
          const removeBtn = e.target.closest(".lbj-wl-remove")
          if (removeBtn) {
            e.preventDefault()
            e.stopPropagation()
            const handle = removeBtn.dataset.remove
            const row = removeBtn.closest(".cart-items__table-row")
            if (row) {
              row.style.transition = "opacity 0.25s ease, transform 0.25s ease, max-height 0.3s ease 0.15s"
              row.style.opacity = "0"
              row.style.transform = "translateX(30px)"
              row.style.pointerEvents = "none"
              row.style.maxHeight = row.offsetHeight + "px"
              row.style.overflow = "hidden"
              requestAnimationFrame(() => { row.style.maxHeight = "0"; row.style.paddingBlock = "0"; row.style.marginBlock = "0" })
              setTimeout(() => row.remove(), 350)
            }
            state.remove(handle)
            priceCache.remove(handle)
            hydrateButtons()
            updateCount()
            // Show empty state if no items left
            const remaining = state.get()
            if (remaining.length === 0) {
              setTimeout(() => renderGrid(grid), 350)
            }
            return
          }

          const addBtn = e.target.closest(".lbj-wl-add")
          if (addBtn) {
            e.preventDefault()
            e.stopPropagation()
            const id = addBtn.dataset.variantId
            const row = addBtn.closest(".cart-items__table-row")
            const handle = row?.dataset.handle
            addBtn.disabled = true
            try {
              await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id, quantity: 1 }),
              })

              if (window.cartDrawer) {
                await window.cartDrawer.refresh()
              }

              addBtn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5C0A13" stroke-width="3" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>`
              addBtn.style.pointerEvents = "none"

              if (handle) {
                state.remove(handle)
                priceCache.remove(handle)
                hydrateButtons()
                updateCount()
              }

              setTimeout(() => {
                if (row) {
                  row.style.transition = "opacity 0.25s ease, transform 0.25s ease, max-height 0.3s ease 0.15s"
                  row.style.opacity = "0"
                  row.style.transform = "translateX(30px)"
                  row.style.pointerEvents = "none"
                  row.style.maxHeight = row.offsetHeight + "px"
                  row.style.overflow = "hidden"
                  requestAnimationFrame(() => { row.style.maxHeight = "0"; row.style.paddingBlock = "0"; row.style.marginBlock = "0" })
                  setTimeout(() => {
                    row.remove()
                    if (state.get().length === 0) renderGrid(grid)
                  }, 350)
                }
              }, 600)
            } catch (_) {
              addBtn.disabled = false
              addBtn.innerHTML = `<span class="lbj-viewbag-text">Add to Bag</span><span class="chevron">›</span>`
            }
            return
          }

        })
        grid._delegated = true
      }
    } catch (_) {
      grid.innerHTML = `<p class="lbj-wl-error">Could not load wishlist.</p>`
    }
  }

  // -------------- toast ------------------
  function toast(msg) {
    const t = document.querySelector(S.toast)
    if (!t) return
    t.textContent = msg
    t.hidden = false
    clearTimeout(t._tid)
    t._tid = setTimeout(() => (t.hidden = true), 1800)
  }

  // ---- header wishlist icon (shadow-aware) ----
  function getHeaderWishlistIcon() {
    let el = document.querySelector(".header-actions__wishlist-icon")
    if (el) return el

    // Check likely shadow host elements rather than iterating the entire DOM
    const shadowHostSelectors = ["header-actions", "header-wrapper", "#shopify-section-header", ".header-wrapper"]
    for (const sel of shadowHostSelectors) {
      const host = document.querySelector(sel)
      if (host?.shadowRoot) {
        el = host.shadowRoot.querySelector(".header-actions__wishlist-icon")
        if (el) return el
      }
    }
    return null
  }

  // -------------- fly animation (add only) --------------
  function flyHeartToHeader(sourceBtn) {
    try {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

      const headerBtn = getHeaderWishlistIcon()
      const svg = sourceBtn.querySelector(".wl-icon, svg")
      if (!headerBtn || !svg) return

      const src = svg.getBoundingClientRect()
      const dest = headerBtn.getBoundingClientRect()

      const clone = document.createElement("div")
      clone.className = "wl-fly-heart"
      clone.style.cssText = `
        position:fixed; left:0; top:0; width:22px; height:22px; z-index:9999;
        pointer-events:none; will-change:transform,opacity;
      `
      clone.innerHTML = svg.outerHTML
      document.body.appendChild(clone)

      const startX = src.left + src.width / 2 - 11
      const startY = src.top + src.height / 2 - 11
      const endX = dest.left + dest.width / 2 - 11
      const endY = dest.top + dest.height / 2 - 11

      clone.animate(
        [
          { transform: `translate(${startX}px, ${startY}px) scale(1)`, opacity: 1 },
          {
            transform: `translate(${(startX + endX) / 2}px, ${Math.min(startY, endY) - 80}px) scale(.9)`,
            opacity: 0.95,
          },
          { transform: `translate(${endX}px, ${endY}px) scale(.6)`, opacity: 0 },
        ],
        {
          duration: 700,
          easing: "cubic-bezier(.22,1,.36,1)",
          fill: "forwards",
        },
      ).onfinish = () => {
        clone.remove()
      }
    } catch (_) {
      /* noop */
    }
  }

  // ---------------- events ----------------
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest(S.btn)
      if (btn) {
        e.preventDefault()
        e.stopPropagation()

        const h = getHandleFrom(btn)
        if (!h) return

        try {
          state.toggle(h)

          const isActive = state.has(h)
          btn.classList.toggle("is-active", isActive)
          btn.setAttribute("aria-pressed", String(isActive))

          // Cache display price (may include closing-sale 35% discount) so
          // the drawer shows the correct price even though the products API
          // doesn't expose metafields.
          if (isActive) {
            const wlPrice = btn.dataset.wlPrice
            if (wlPrice) priceCache.set(h, { price: wlPrice, compare: btn.dataset.wlCompare || "" })
          } else {
            priceCache.remove(h)
          }

          void btn.offsetHeight

          // Defer sync work
          requestAnimationFrame(() => {
            hydrateButtons()
            updateCount()
            if (isActive) requestAnimationFrame(() => flyHeartToHeader(btn))

            const root = drawerRoot()
            const grid = (root && isOpen() && root.querySelector(S.grid)) || document.querySelector(S.grid)
            if (grid) renderGrid(grid)
          })

          toast(
            isActive
              ? btn.dataset.addedText || "Added to wishlist"
              : btn.dataset.removedText || "Removed from wishlist",
          )
        } catch (err) {
          console.error("LBJ Wishlist toggle error:", err)
        }
        return
      }

      // Open/close drawer
      if (e.target.closest(S.open)) {
        openWishlist()
        return
      }
      if (e.target.closest(S.close)) {
        closeWishlist()
        return
      }
    },
    { passive: false },
  )

  // ESC closes
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeWishlist()
  })

  function revealOverlayWraps() {
    document.querySelectorAll(".lbj-wl-overlay-wrap--hidden").forEach((wrap) => {
      const img = wrap.querySelector(".wl-icon-default")
      if (!img) { wrap.classList.remove("lbj-wl-overlay-wrap--hidden"); return }
      if (img.complete) { wrap.classList.remove("lbj-wl-overlay-wrap--hidden"); return }
      img.addEventListener("load", () => wrap.classList.remove("lbj-wl-overlay-wrap--hidden"), { once: true })
    })
  }

  // Debounced DOM mutations (sliders, AJAX inserts)
  let moTimer = null
  const mo = new MutationObserver(() => {
    clearTimeout(moTimer)
    moTimer = setTimeout(() => {
      hydrateButtons()
      updateCount()
      revealOverlayWraps()
    }, 50)
  })
  mo.observe(document.documentElement, { childList: true, subtree: true })

  // React to external updates
  document.addEventListener("lbj:wishlist:change", () => {
    hydrateButtons()
    updateCount()
    if (isOpen()) {
      const root = drawerRoot()
      const grid = root && root.querySelector(S.grid)
      if (grid) renderGrid(grid)
    }
  })

  // Defensive backdrop close for <dialog>
  document.addEventListener("click", (e) => {
    const dlg = drawerDialog()
    if (!dlg || !dlg.open) return
    if (e.target === dlg) closeWishlist()
  })

  // --------------- share -------------------
  function updateShareRow() {
    const row = document.getElementById("wl-share-row")
    if (!row) return
    row.hidden = state.get().length === 0
  }

  document.addEventListener("click", (e) => {
    const shareBtn = e.target.closest("#wl-share-btn")
    if (!shareBtn) return
    const handles = state.get()
    if (!handles.length) return
    const url = location.origin + "/?wl=" + encodeURIComponent(handles.join(","))

    // Try native share first (mobile), fall back to clipboard
    if (navigator.share) {
      navigator.share({ title: "My Wishlist", url }).catch(() => {})
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(() => {
        const toastEl = document.getElementById("wl-share-toast")
        if (toastEl) {
          toastEl.classList.add("is-visible")
          setTimeout(() => toastEl.classList.remove("is-visible"), 2000)
        }
      })
    }
  })

  document.addEventListener("lbj:wishlist:change", updateShareRow)

  // --------------- init -------------------
  function initWishlist() {
    try {
      hydrateButtons()
      updateCount()
      updateShareRow()

      if (isOpen()) {
        const root = drawerRoot()
        const grid = root && root.querySelector(S.grid)
        if (grid) renderGrid(grid)
      }

      // Import from ?wl=handle,handle
      const wl = new URL(location.href).searchParams.get("wl")
      if (wl) {
        const incoming = wl
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)
        if (incoming.length) {
          state.set([...new Set([...state.get(), ...incoming])])
          hydrateButtons()
          updateCount()
          updateShareRow()

          // Clean URL and auto-open wishlist drawer
          const cleanUrl = new URL(location.href)
          cleanUrl.searchParams.delete("wl")
          history.replaceState(null, "", cleanUrl.toString())
          setTimeout(() => openWishlist(), 300)
        }
      }

      // Open/close is handled by the delegated document click listener above
    } catch (e) {
      console.error("LBJ Wishlist init error:", e)
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWishlist, { once: true })
  } else {
    initWishlist()
  }

  // If drawer was opened before page fully loaded, restore it after load
  window.addEventListener("load", () => {
    if (_intentOpen && !isOpen()) openWishlist()
  }, { once: true })

  window.addEventListener("pageshow", () => updateCount())

  // export
  window.LBJWishlist = {
    get: state.get,
    toggle: state.toggle,
    add: state.add,
    remove: state.remove,
    open: openWishlist,
    close: closeWishlist,
  }
})()
 